function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { useState } from 'react';
import { Icon } from '@cb/apricot-react';
import Spinner from '../apricot/Spinner';
import Error from '../apricot/Error';
import Breakpoint from '../breakpoint';
import SchoolBand from './SchoolBand';
import Mobile from './Mobile';
import Panels from './Panels';
import styles from '../../../sass/status.module.scss';

// configurable properities
// loading (optional, shows spinner)
// error (optional, shows error component)
// data (required to show panel)
// showSchoolBand (optional, shows band with coordinator, principal and access codes)
// hideOrderPanel (optional, defaults to false)
// hideStudentRegistrations (optional, defaults to false)
// history (optional, create links using react router vs regular hyperlinks vs no links (value will be false))
// AdditionalCostComponent (optional, will add the provided component to Cost panel)
export default Breakpoint(function (_ref) {
  var _ref$hideOrderPanel = _ref.hideOrderPanel,
    hideOrderPanel = _ref$hideOrderPanel === void 0 ? false : _ref$hideOrderPanel,
    _ref$showSchoolBand = _ref.showSchoolBand,
    showSchoolBand = _ref$showSchoolBand === void 0 ? true : _ref$showSchoolBand,
    _ref$hideStudentRegis = _ref.hideStudentRegistrations,
    hideStudentRegistrations = _ref$hideStudentRegis === void 0 ? false : _ref$hideStudentRegis,
    history = _ref.history,
    loading = _ref.loading,
    error = _ref.error,
    data = _ref.data,
    AdditionalCostComponent = _ref.AdditionalCostComponent,
    _ref$breakpoint = _ref.breakpoint,
    mobile = _ref$breakpoint.mobile,
    tablet = _ref$breakpoint.tablet;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    open = _useState2[0],
    setOpen = _useState2[1];
  var props = _objectSpread(_objectSpread({}, data), {}, {
    hideOrderPanel: hideOrderPanel,
    hideStudentRegistrations: hideStudentRegistrations,
    history: history,
    AdditionalCostComponent: AdditionalCostComponent
  });
  if (loading) {
    return /*#__PURE__*/React.createElement(Spinner, null);
  }
  if (error) {
    return /*#__PURE__*/React.createElement(Error, {
      message: error,
      title: "Error retrieving status information"
    });
  }
  if (data) return /*#__PURE__*/React.createElement("div", {
    "aria-label": "Status Panel",
    role: "region",
    className: styles['status-container']
  }, showSchoolBand && !mobile && !tablet ? /*#__PURE__*/React.createElement(SchoolBand, data.school) : null, mobile ? /*#__PURE__*/React.createElement("button", {
    type: "button",
    "aria-expanded": open,
    className: styles['status-button'],
    onClick: function onClick() {
      return setOpen(!open);
    }
  }, open ? 'Collapse' : 'Expand', " Status ", /*#__PURE__*/React.createElement(Icon, {
    name: open ? 'minus' : 'plus'
  })) : null, mobile && !open ? /*#__PURE__*/React.createElement(Mobile, props) : /*#__PURE__*/React.createElement(Panels, props));
  return null;
});